import { render, staticRenderFns } from "./ResumeItemListItem.vue?vue&type=template&id=1824eb1f&scoped=true&"
import script from "./ResumeItemListItem.vue?vue&type=script&lang=js&"
export * from "./ResumeItemListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824eb1f",
  null
  
)

export default component.exports